
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".country-btn");
    const container = document.querySelector(".cc-items");
    const items = document.querySelectorAll(".cc-items .cc-item");

    if (!container || !items.length) {
        return;
    }

    function normalizeText(str) {
        return String(str || "").trim();
    }

    function getSortOrder(item) {
        const value = parseInt(item.dataset.sortOrder, 10);
        return Number.isNaN(value) ? 0 : value;
    }

    function sortItemsDesc() {
        const sortedItems = Array.from(items).sort(function (a, b) {
            return getSortOrder(b) - getSortOrder(a);
        });

        sortedItems.forEach(function (item) {
            container.appendChild(item);
        });
    }

    function filterItems(area) {
        const currentItems = Array.from(container.querySelectorAll(".cc-item"));

        currentItems.forEach(function (item, index) {
            const itemArea = normalizeText(item.dataset.area);

            if (area === "Popular") {
                item.style.display = index < 24 ? "" : "none";
                return;
            }

            if (!area) {
                item.style.display = "";
                return;
            }

            if (area === "All") {
                item.style.display = itemArea !== "Tour" ? "" : "none";
                return;
            }

            item.style.display = itemArea === area ? "" : "none";
        });
    }

    function setActiveButton(clickedButton) {
        const area = normalizeText(clickedButton.dataset.area);
        buttons.forEach(function (button) {
            button.classList.remove("active");
        });

        if (area == 'Popular') {
            document.getElementById('area-select-popular').classList.add('active');
        }

        if (area == 'Tour') {
            document.getElementById('country-btns').style.display = 'none';
        } else {
            document.getElementById('country-btns').style.display = 'block';
        }
        if (area != 'Tour') {
            document.getElementById('area-type-select-countries').classList.add('active');
        } else {
            document.getElementById('area-type-select-countries').classList.remove('active');
        }
        clickedButton.classList.add("active");
    }

    sortItemsDesc();

    if (!buttons.length) {
        return;
    }

    buttons.forEach(function (button) {
        button.addEventListener("click", function () {
            const area = normalizeText(button.dataset.area);
            setActiveButton(button);
            filterItems(area);
        });
    });

    const initialButton = document.querySelector('.country-btn[data-area="Popular"]');
    if (initialButton) {
        setActiveButton(initialButton);
        filterItems("Popular");
    }
});

